import * as ambassadorWixQuickpagesV1Page from './quickpages-v1-page-pages.http.js';
import * as ambassadorWixQuickpagesV1PageTypes from './quickpages-v1-page-pages.types.js';
import * as ambassadorWixQuickpagesV1PageUniversalTypes from './quickpages-v1-page-pages.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createPage(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixQuickpagesV1PageUniversalTypes.CreatePageRequest,
  ambassadorWixQuickpagesV1PageTypes.CreatePageRequest,
  ambassadorWixQuickpagesV1PageUniversalTypes.CreatePageResponse,
  ambassadorWixQuickpagesV1PageTypes.CreatePageResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixQuickpagesV1Page.createPage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/pages',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPage(): __PublicMethodMetaInfo<
  'GET',
  { pageId: string },
  ambassadorWixQuickpagesV1PageUniversalTypes.GetPageRequest,
  ambassadorWixQuickpagesV1PageTypes.GetPageRequest,
  ambassadorWixQuickpagesV1PageUniversalTypes.GetPageResponse,
  ambassadorWixQuickpagesV1PageTypes.GetPageResponse
> {
  const payload = { pageId: ':pageId' } as any;

  const getRequestOptions = ambassadorWixQuickpagesV1Page.getPage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/pages/{pageId}',
    pathParams: { pageId: 'pageId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updatePage(): __PublicMethodMetaInfo<
  'PATCH',
  { pageId: string },
  ambassadorWixQuickpagesV1PageUniversalTypes.UpdatePageRequest,
  ambassadorWixQuickpagesV1PageTypes.UpdatePageRequest,
  ambassadorWixQuickpagesV1PageUniversalTypes.UpdatePageResponse,
  ambassadorWixQuickpagesV1PageTypes.UpdatePageResponse
> {
  const payload = { page: { id: ':pageId' } } as any;

  const getRequestOptions = ambassadorWixQuickpagesV1Page.updatePage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/pages/{page.id}',
    pathParams: { pageId: 'pageId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setPageRoute(): __PublicMethodMetaInfo<
  'PATCH',
  { pageId: string },
  ambassadorWixQuickpagesV1PageUniversalTypes.SetPageRouteRequest,
  ambassadorWixQuickpagesV1PageTypes.SetPageRouteRequest,
  ambassadorWixQuickpagesV1PageUniversalTypes.SetPageRouteResponse,
  ambassadorWixQuickpagesV1PageTypes.SetPageRouteResponse
> {
  const payload = { pageId: ':pageId' } as any;

  const getRequestOptions = ambassadorWixQuickpagesV1Page.setPageRoute(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/pages/{pageId}/routes',
    pathParams: { pageId: 'pageId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removePageRoute(): __PublicMethodMetaInfo<
  'DELETE',
  { pageId: string },
  ambassadorWixQuickpagesV1PageUniversalTypes.RemovePageRouteRequest,
  ambassadorWixQuickpagesV1PageTypes.RemovePageRouteRequest,
  ambassadorWixQuickpagesV1PageUniversalTypes.RemovePageRouteResponse,
  ambassadorWixQuickpagesV1PageTypes.RemovePageRouteResponse
> {
  const payload = { pageId: ':pageId' } as any;

  const getRequestOptions =
    ambassadorWixQuickpagesV1Page.removePageRoute(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/pages/{pageId}/routes',
    pathParams: { pageId: 'pageId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function publishPage(): __PublicMethodMetaInfo<
  'POST',
  { pageId: string },
  ambassadorWixQuickpagesV1PageUniversalTypes.PublishPageRequest,
  ambassadorWixQuickpagesV1PageTypes.PublishPageRequest,
  ambassadorWixQuickpagesV1PageUniversalTypes.PublishPageResponse,
  ambassadorWixQuickpagesV1PageTypes.PublishPageResponse
> {
  const payload = { pageId: ':pageId' } as any;

  const getRequestOptions = ambassadorWixQuickpagesV1Page.publishPage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/pages/{pageId}/publish',
    pathParams: { pageId: 'pageId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function unpublishPage(): __PublicMethodMetaInfo<
  'POST',
  { pageId: string },
  ambassadorWixQuickpagesV1PageUniversalTypes.UnpublishPageRequest,
  ambassadorWixQuickpagesV1PageTypes.UnpublishPageRequest,
  ambassadorWixQuickpagesV1PageUniversalTypes.UnpublishPageResponse,
  ambassadorWixQuickpagesV1PageTypes.UnpublishPageResponse
> {
  const payload = { pageId: ':pageId' } as any;

  const getRequestOptions =
    ambassadorWixQuickpagesV1Page.unpublishPage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/pages/{pageId}/unpublish',
    pathParams: { pageId: 'pageId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function archivePage(): __PublicMethodMetaInfo<
  'POST',
  { pageId: string },
  ambassadorWixQuickpagesV1PageUniversalTypes.ArchivePageRequest,
  ambassadorWixQuickpagesV1PageTypes.ArchivePageRequest,
  ambassadorWixQuickpagesV1PageUniversalTypes.ArchivePageResponse,
  ambassadorWixQuickpagesV1PageTypes.ArchivePageResponse
> {
  const payload = { pageId: ':pageId' } as any;

  const getRequestOptions = ambassadorWixQuickpagesV1Page.archivePage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/pages/{pageId}/archive',
    pathParams: { pageId: 'pageId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function unarchivePage(): __PublicMethodMetaInfo<
  'POST',
  { pageId: string },
  ambassadorWixQuickpagesV1PageUniversalTypes.UnarchivePageRequest,
  ambassadorWixQuickpagesV1PageTypes.UnarchivePageRequest,
  ambassadorWixQuickpagesV1PageUniversalTypes.UnarchivePageResponse,
  ambassadorWixQuickpagesV1PageTypes.UnarchivePageResponse
> {
  const payload = { pageId: ':pageId' } as any;

  const getRequestOptions =
    ambassadorWixQuickpagesV1Page.unarchivePage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/pages/{pageId}/unarchive',
    pathParams: { pageId: 'pageId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function schedulePage(): __PublicMethodMetaInfo<
  'POST',
  { pageId: string },
  ambassadorWixQuickpagesV1PageUniversalTypes.SchedulePageRequest,
  ambassadorWixQuickpagesV1PageTypes.SchedulePageRequest,
  ambassadorWixQuickpagesV1PageUniversalTypes.SchedulePageResponse,
  ambassadorWixQuickpagesV1PageTypes.SchedulePageResponse
> {
  const payload = { pageId: ':pageId' } as any;

  const getRequestOptions = ambassadorWixQuickpagesV1Page.schedulePage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/pages/{pageId}/schedule',
    pathParams: { pageId: 'pageId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deletePage(): __PublicMethodMetaInfo<
  'DELETE',
  { pageId: string },
  ambassadorWixQuickpagesV1PageUniversalTypes.DeletePageRequest,
  ambassadorWixQuickpagesV1PageTypes.DeletePageRequest,
  ambassadorWixQuickpagesV1PageUniversalTypes.DeletePageResponse,
  ambassadorWixQuickpagesV1PageTypes.DeletePageResponse
> {
  const payload = { pageId: ':pageId' } as any;

  const getRequestOptions = ambassadorWixQuickpagesV1Page.deletePage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/pages/{pageId}',
    pathParams: { pageId: 'pageId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryPages(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixQuickpagesV1PageUniversalTypes.QueryPagesRequest,
  ambassadorWixQuickpagesV1PageTypes.QueryPagesRequest,
  ambassadorWixQuickpagesV1PageUniversalTypes.QueryPagesResponse,
  ambassadorWixQuickpagesV1PageTypes.QueryPagesResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixQuickpagesV1Page.queryPages(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/pages/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdatePageTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixQuickpagesV1PageUniversalTypes.BulkUpdatePageTagsRequest,
  ambassadorWixQuickpagesV1PageTypes.BulkUpdatePageTagsRequest,
  ambassadorWixQuickpagesV1PageUniversalTypes.BulkUpdatePageTagsResponse,
  ambassadorWixQuickpagesV1PageTypes.BulkUpdatePageTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixQuickpagesV1Page.bulkUpdatePageTags(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/pages/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdatePageTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixQuickpagesV1PageUniversalTypes.BulkUpdatePageTagsByFilterRequest,
  ambassadorWixQuickpagesV1PageTypes.BulkUpdatePageTagsByFilterRequest,
  ambassadorWixQuickpagesV1PageUniversalTypes.BulkUpdatePageTagsByFilterResponse,
  ambassadorWixQuickpagesV1PageTypes.BulkUpdatePageTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixQuickpagesV1Page.bulkUpdatePageTagsByFilter(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/pages/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Page as PageOriginal,
  PageOriginOneOf as PageOriginOneOfOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  Image as ImageOriginal,
  PageRoute as PageRouteOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  PagePublished as PagePublishedOriginal,
  PageUnpublished as PageUnpublishedOriginal,
  PageArchived as PageArchivedOriginal,
  PageUnarchived as PageUnarchivedOriginal,
  PageScheduled as PageScheduledOriginal,
  CreatePageRequest as CreatePageRequestOriginal,
  CreatePageResponse as CreatePageResponseOriginal,
  GetPageRequest as GetPageRequestOriginal,
  GetPageResponse as GetPageResponseOriginal,
  UpdatePageRequest as UpdatePageRequestOriginal,
  UpdatePageResponse as UpdatePageResponseOriginal,
  SetPageRouteRequest as SetPageRouteRequestOriginal,
  SetPageRouteResponse as SetPageRouteResponseOriginal,
  RemovePageRouteRequest as RemovePageRouteRequestOriginal,
  RemovePageRouteResponse as RemovePageRouteResponseOriginal,
  PublishPageRequest as PublishPageRequestOriginal,
  PublishPageResponse as PublishPageResponseOriginal,
  UnpublishPageRequest as UnpublishPageRequestOriginal,
  UnpublishPageResponse as UnpublishPageResponseOriginal,
  ArchivePageRequest as ArchivePageRequestOriginal,
  ArchivePageResponse as ArchivePageResponseOriginal,
  UnarchivePageRequest as UnarchivePageRequestOriginal,
  UnarchivePageResponse as UnarchivePageResponseOriginal,
  SchedulePageRequest as SchedulePageRequestOriginal,
  SchedulePageResponse as SchedulePageResponseOriginal,
  DeletePageRequest as DeletePageRequestOriginal,
  DeletePageResponse as DeletePageResponseOriginal,
  QueryPagesRequest as QueryPagesRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryPagesResponse as QueryPagesResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  BulkUpdatePageTagsRequest as BulkUpdatePageTagsRequestOriginal,
  BulkUpdatePageTagsResponse as BulkUpdatePageTagsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkUpdatePageTagsResult as BulkUpdatePageTagsResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdatePageTagsByFilterRequest as BulkUpdatePageTagsByFilterRequestOriginal,
  BulkUpdatePageTagsByFilterResponse as BulkUpdatePageTagsByFilterResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  BulkUpdatePageTagsApplicationErrors as BulkUpdatePageTagsApplicationErrorsOriginal,
  BulkUpdatePageTagsByFilterApplicationErrors as BulkUpdatePageTagsByFilterApplicationErrorsOriginal,
} from './quickpages-v1-page-pages.types.js';
